import {default as Targeting} from './Targeting'

export default {
    Targeting,
}